<template>
    <div>
        <section class="player-list">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <h2 class="section-subtitle">Přehled týmů</h2>
                        <v-row>
                            <v-col cols="14" offset="1" sm="10" offset-sm="3">
                                <v-form>
                                    <v-text-field
                                        v-model="searchPhrase"
                                        dark
                                        return-object
                                        clearable
                                        hide-details
                                        append-icon="mdi-magnify"
                                        label="HLEDAT TÝM"
                                    ></v-text-field>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="player-list player-list--grey">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <h2 class="section-subtitle section-subtitle--smallerleft">Přehled týmů</h2>

                        <v-data-table
                            :headers="header"
                            :items="teams"
                            :search="searchPhrase"
                            :loading="loading"
                            must-sort
                            sort-by="name"
                            :items-per-page="100"
                            :footer-props="{ itemsPerPageOptions: [100], disableItemsPerPage: true }"
                            class="transparent"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td>
                                        <div class="order__flex order__flex--start">
                                            <team-blazon-view :settings="props.item.blazon" class="small" />
                                            <span>{{ props.item.name }}</span>
                                        </div>
                                    </td>
                                    <td>{{ props.item.players }}</td>
                                    <td>
                                        <div class="team-members__flex">
                                            <v-btn dark large class="btn-without-border" icon
                                                   :to="{ name: 'teamDetail', params: { id: props.item.id } }">
                                                Detail
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>

                    </v-col>
                </v-row>

            </v-container>
        </section>
    </div>
</template>

<script>
    import { LISTING_TEAMS_REQUEST } from '../store/actions/team'
    import TeamBlazonView from '../components/TeamBlazon/TeamBlazonView';

    export default {
        components: { TeamBlazonView },
        data () {
            return {
                header: [
                    {
                        text: 'Tým',
                        value: 'name',
                    },
                    {
                        text: 'Členů',
                        value: 'players',
                    },
                    {
                        text: 'Akce',
                        value: 'id',
                        sortable: false,
                        align: 'center',
                        width: 60,
                    },
                ],
                searchPhrase: '',
                teams: [],
                loading: false,
            };
        },
        async created () {
            try {
                this.loading = true;
                this.teams = await this.$store.dispatch('team/' + LISTING_TEAMS_REQUEST);
            } catch (e) {
                this.$toast.error('Došlo k chybě při načítání týmů. Zkuste to později.');
            } finally {
                this.loading = false;
            }
        },
    }
</script>
